var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVooley(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 226,
    height: 222,
    viewBox: "0 0 226 222",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M116.769 208.267C172.514 208.267 217.704 164.791 217.704 111.16C217.704 57.5286 172.514 14.052 116.769 14.052C61.0242 14.052 15.834 57.5286 15.834 111.16C15.834 164.791 61.0242 208.267 116.769 208.267Z",
    stroke: "white",
    strokeWidth: 16.39,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M159.569 198.29C159.569 198.29 170.384 128.653 115.255 111.276",
    stroke: "white",
    strokeWidth: 16.39,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7545 157.317C31.7545 157.317 85.67 179.906 148.969 145.111",
    stroke: "white",
    strokeWidth: 16.39,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M180.768 35.3175C180.768 35.3175 112.353 58.1036 122.267 114.476",
    stroke: "white",
    strokeWidth: 16.39,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M201.596 163.101C201.596 163.101 197.897 107.492 137.733 68.8475",
    stroke: "white",
    strokeWidth: 16.39,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9167 97.684C19.9167 97.684 75.6881 142.71 120.858 106.359",
    stroke: "white",
    strokeWidth: 16.39,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M124.24 14.5852C124.24 14.5852 75.494 46.7348 72.4688 116.303",
    stroke: "white",
    strokeWidth: 16.39,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVooley);
export default __webpack_public_path__ + "static/media/vooley.3074badf0adb5210452ef386bfdce580.svg";
export { ForwardRef as ReactComponent };